// /* eslint-disable */
// 'use client';

// import {
//   Box, Flex, Text, useColorModeValue, Table, Thead, Tbody, Tr, Th, Td,
//   Badge, Button, Input, Switch, useToast, Modal, ModalOverlay, Select,
//   ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
//   FormControl, FormLabel, useDisclosure, Textarea, IconButton, Stack, Spinner
// } from '@chakra-ui/react';
// import axios from 'axios';
// import * as React from 'react';
// import { EditIcon, AddIcon, DeleteIcon, SmallAddIcon } from '@chakra-ui/icons';
// import Card from 'components/card/Card';

// export default function SubscriptionPlans() {
//   const [plans, setPlans] = React.useState([]);
//   const [editingPlan, setEditingPlan] = React.useState(null);
//   const [loading, setLoading] = React.useState(true);
//   const [saving, setSaving] = React.useState(false);

//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const toast = useToast();

//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
//   const token = localStorage.getItem('token');

//   // Form Initial State
//   const initialForm = {
//     name: '',
//     features: '',
//     pricing: [{ months: 1, price: '' }],
//     isActive: true,
//   };

//   const [formData, setFormData] = React.useState(initialForm);

//   // 🟢 1. Fetch Plans (Backend Endpoint: /api/plans/admin/all-plans)
//   const fetchPlans = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}api/plans/admin/all-plans`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response.data.status) {
//         setPlans(response.data.data);
//       }
//     } catch (err) {
//       console.error("Fetch Error:", err);
//       toast({ title: 'Error loading plans', description: 'Backend connection failed', status: 'error', position: 'top-right' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   React.useEffect(() => { fetchPlans(); }, []);

//   // 🟢 2. Pricing Row Handlers
//   const addPricingRow = () => {
//     setFormData({ ...formData, pricing: [...formData.pricing, { months: 1, price: '' }] });
//   };

//   const removePricingRow = (index) => {
//     const newPricing = formData.pricing.filter((_, i) => i !== index);
//     setFormData({ ...formData, pricing: newPricing });
//   };

//   const handlePricingChange = (index, field, value) => {
//     const newPricing = [...formData.pricing];
//     newPricing[index][field] = field === 'price' ? value : Number(value);
//     setFormData({ ...formData, pricing: newPricing });
//   };

//   // 🟢 3. Modal Controls
//   const handleOpenModal = (plan = null) => {
//     if (plan) {
//       setEditingPlan(plan);
//       setFormData({
//         name: plan.name,
//         isActive: plan.isActive,
//         features: plan.features?.join(', ') || '',
//         pricing: plan.pricing?.length > 0 ? plan.pricing : [{ months: 1, price: '' }],
//       });
//     } else {
//       setEditingPlan(null);
//       setFormData(initialForm);
//     }
//     onOpen();
//   };

//   // 🟢 4. Save Logic (Backend Endpoints: /create-plan & /update-plan)
//   const handleSave = async () => {
//     if (!formData.name || formData.pricing.some(p => !p.price)) {
//       return toast({ title: "Validation Error", description: "Please fill all fields", status: "warning" });
//     }

//     setSaving(true);
//     try {
//       const payload = {
//         ...formData,
//         pricing: formData.pricing.map(p => ({ months: Number(p.months), price: Number(p.price) })),
//         features: formData.features.split(',').map(f => f.trim()).filter(f => f !== ''),
//       };

//       // Match your backend route structure
//       const url = editingPlan
//         ? `${baseUrl}api/plans/update-plan/${editingPlan._id}`
//         : `${baseUrl}api/plans/create-plan`;

//       const method = editingPlan ? 'put' : 'post';

//       const response = await axios[method](url, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (response.data.status) {
//         toast({ title: 'Plan Saved Successfully', status: 'success' });
//         fetchPlans();
//         onClose();
//       }
//     } catch (err) {
//       toast({ title: 'Operation failed', description: err.response?.data?.message || 'Server Error', status: 'error' });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Card flexDirection="column" w="100%" px="25px" py="25px" mt="80px" boxShadow="lg" borderRadius="20px">
//       <Flex mb="30px" justifyContent="space-between" align="center">
//         <Box>
//           <Text color={textColor} fontSize="22px" fontWeight="700">Subscription Plans</Text>
//           <Text color="secondaryGray.600" fontSize="sm">Manage plan pricing and features</Text>
//         </Box>
//         <Button leftIcon={<AddIcon />} colorScheme="brand" onClick={() => handleOpenModal()}>
//           Create Plan
//         </Button>
//       </Flex>

//       {loading ? (
//         <Flex justify="center" align="center" minH="200px"><Spinner /></Flex>
//       ) : (
//         <Box overflowX="auto">
//           <Table variant="simple" color={textColor}>
//             <Thead bg={useColorModeValue('gray.50', 'navy.800')}>
//               <Tr>
//                 <Th>Plan Name</Th>
//                 <Th>Pricing Tiers (Months : Price)</Th>
//                 <Th>Features</Th>
//                 <Th>Status</Th>
//                 <Th>Actions</Th>
//               </Tr>
//             </Thead>
//             <Tbody>
//               {plans.map((plan) => (
//                 <Tr key={plan._id}>
//                   <Td fontWeight="bold" fontSize="sm">{plan.name}</Td>
//                   <Td>
//                     <Stack direction="row" flexWrap="wrap" gap={2}>
//                       {plan.pricing?.map((p, i) => (
//                         <Badge key={i} colorScheme="purple" variant="subtle" borderRadius="full" px={2}>
//                           {p.months}M : ₹{p.price}
//                         </Badge>
//                       ))}
//                     </Stack>
//                   </Td>
//                   <Td>
//                     <Text noOfLines={1} fontSize="xs" maxW="200px" color="gray.500">
//                       {plan.features?.join(', ')}
//                     </Text>
//                   </Td>
//                   <Td>
//                     <Badge colorScheme={plan.isActive ? 'green' : 'red'}>
//                       {plan.isActive ? 'Active' : 'Inactive'}
//                     </Badge>
//                   </Td>
//                   <Td>
//                     <Flex gap={2}>
//                       <IconButton icon={<EditIcon />} size="sm" variant="outline" onClick={() => handleOpenModal(plan)} aria-label="Edit" />
//                     </Flex>
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         </Box>
//       )}

//       {/* 🟢 Add/Edit Modal */}
//       <Modal isOpen={isOpen} onClose={onClose} size="xl">
//         <ModalOverlay />
//         <ModalContent borderRadius="15px">
//           <ModalHeader borderBottom="1px solid" borderColor="gray.100">
//             {editingPlan ? 'Update Plan Details' : 'Create New Subscription'}
//           </ModalHeader>
//           <ModalCloseButton />
//           <ModalBody py={6}>
//             <Stack spacing={5}>
//               <FormControl isRequired>
//                 <FormLabel fontWeight="600">Plan Name</FormLabel>
//                 <Input placeholder="e.g. Professional Plus" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
//               </FormControl>

//               <Box p={4} bg={useColorModeValue('gray.50', 'whiteAlpha.100')} borderRadius="12px">
//                 <Flex justify="space-between" align="center" mb={4}>
//                   <Text fontWeight="700" fontSize="sm">Pricing Variants</Text>
//                   <Button size="xs" colorScheme="brand" variant="ghost" leftIcon={<SmallAddIcon />} onClick={addPricingRow}>
//                     Add New Row
//                   </Button>
//                 </Flex>

//                 {formData.pricing.map((tier, index) => (
//                   <Flex key={index} gap={3} mb={3} align="center">
//                     <Select flex="1" value={tier.months} onChange={(e) => handlePricingChange(index, 'months', e.target.value)}>
//                       <option value={1}>1 Month</option>
//                       <option value={3}>3 Months</option>
//                       <option value={6}>6 Months</option>
//                       <option value={12}>1 Year</option>
//                       <option value={24}>2 Year</option>
//                     </Select>
//                     <Input flex="1" type="number" placeholder="Price (₹)" value={tier.price} onChange={(e) => handlePricingChange(index, 'price', e.target.value)} />
//                     <IconButton icon={<DeleteIcon />} size="sm" colorScheme="red" variant="ghost" onClick={() => removePricingRow(index)} isDisabled={formData.pricing.length === 1} />
//                   </Flex>
//                 ))}
//               </Box>

//               <FormControl>
//                 <FormLabel fontWeight="600">Plan Features</FormLabel>
//                 <Textarea placeholder="24/7 Support, Premium Content, Unlimited Downloads (Comma separated)" value={formData.features} onChange={(e) => setFormData({ ...formData, features: e.target.value })} />
//               </FormControl>

//               <FormControl display="flex" alignItems="center">
//                 <FormLabel mb="0" fontWeight="600">Is Plan Active?</FormLabel>
//                 <Switch isChecked={formData.isActive} onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })} />
//               </FormControl>
//             </Stack>
//           </ModalBody>

//           <ModalFooter borderTop="1px solid" borderColor="gray.100">
//             <Button variant="ghost" mr={3} onClick={onClose}>Cancel</Button>
//             <Button colorScheme="brand" isLoading={saving} onClick={handleSave} px={8}>
//               {editingPlan ? 'Update Plan' : 'Save Plan'}
//             </Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Card>
//   );
// }

/* eslint-disable */
'use client';

import {
  Badge,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Spinner,
  Stack,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon, EditIcon, InfoOutlineIcon, SmallAddIcon } from '@chakra-ui/icons';
import axios from 'axios';
import * as React from 'react';
import Card from 'components/card/Card';

const MONTH_OPTIONS = [
  { value: 1, label: '1 Month' },
  { value: 3, label: '3 Months' },
  { value: 6, label: '6 Months' },
  { value: 12, label: '1 Year' },
  { value: 24, label: '2 Years' },
];

const toNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

const createEmptyPricingRow = () => ({
  durationType: 'months',
  months: 1,
  extraMonths: 0,
  totalMonths: 1,
  days: 0,
  price: '',
  perDay: 0,
  planLabel: '',
  discountLabel: '',
});

const createInitialForm = () => ({
  name: '',
  iosProductId: '',
  features: '',
  pricing: [createEmptyPricingRow()],
  isActive: true,
});

const getPlanIosProductId = (plan = {}) =>
  plan.iosProductId || plan.ios_product_id || plan.appleProductId || '';

const normalizePricingForForm = (pricing = {}) => {
  const durationType = pricing.durationType === 'days' ? 'days' : 'months';
  const months = durationType === 'months' ? toNumber(pricing.months, 1) || 1 : 0;
  const extraMonths = durationType === 'months' ? toNumber(pricing.extraMonths, 0) : 0;
  const days = durationType === 'days' ? toNumber(pricing.days, 1) || 1 : 0;

  return {
    durationType,
    months,
    extraMonths,
    totalMonths:
      durationType === 'months'
        ? toNumber(pricing.totalMonths, months + extraMonths)
        : 0,
    days,
    price: pricing.price ?? '',
    perDay: pricing.perDay ?? 0,
    planLabel: pricing.planLabel || '',
    discountLabel: pricing.discountLabel || '',
  };
};

const buildPricingPayload = (pricing) => {
  const durationType = pricing.durationType === 'days' ? 'days' : 'months';
  const months = durationType === 'months' ? toNumber(pricing.months, 0) : 0;
  const extraMonths =
    durationType === 'months' ? toNumber(pricing.extraMonths, 0) : 0;
  const totalMonths = durationType === 'months' ? months + extraMonths : 0;
  const days = durationType === 'days' ? toNumber(pricing.days, 0) : 0;
  const price = toNumber(pricing.price, 0);
  const totalDays = durationType === 'days' ? days : totalMonths * 30;

  return {
    durationType,
    months,
    extraMonths,
    totalMonths,
    days,
    price,
    perDay: totalDays > 0 ? Number((price / totalDays).toFixed(2)) : 0,
    planLabel:
      durationType === 'days'
        ? `${days} Days`
        : `${months}M + ${extraMonths}M FREE`,
    discountLabel: pricing.discountLabel?.trim() || '',
  };
};

const getDurationLabel = (pricing = {}) => {
  if (pricing.durationType === 'days') {
    return `${pricing.days || 0}D`;
  }

  const extra = Number(pricing.extraMonths || 0);
  return extra > 0
    ? `${pricing.months || 0}M + ${extra}M`
    : `${pricing.months || 0}M`;
};

export default function SubscriptionPlans() {
  const [plans, setPlans] = React.useState([]);
  const [editingPlan, setEditingPlan] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);
  const [formData, setFormData] = React.useState(createInitialForm);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const mutedText = useColorModeValue('secondaryGray.600', 'gray.400');
  const theadBg = useColorModeValue('gray.50', 'navy.800');
  const pricingBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const pricingRowBg = useColorModeValue('white', 'navy.900');
  const rowBorder = useColorModeValue('gray.200', 'whiteAlpha.200');

  const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
  const token = localStorage.getItem('token');
  const authHeader = React.useMemo(
    () => ({ headers: { Authorization: `Bearer ${token}` } }),
    [token]
  );

  const fetchPlans = React.useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${baseUrl}api/plans/admin/all-plans`,
        authHeader
      );

      if (data.status) {
        setPlans(Array.isArray(data.data) ? data.data : []);
      }
    } catch (error) {
      toast({
        title: 'Error loading plans',
        description: error.response?.data?.message || 'Backend connection failed',
        status: 'error',
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  }, [authHeader, baseUrl, toast]);

  React.useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  const addPricingRow = () => {
    setFormData((prev) => ({
      ...prev,
      pricing: [...prev.pricing, createEmptyPricingRow()],
    }));
  };

  const removePricingRow = (index) => {
    setFormData((prev) => ({
      ...prev,
      pricing: prev.pricing.filter((_, rowIndex) => rowIndex !== index),
    }));
  };

  const handlePricingChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = prev.pricing.map((row, rowIndex) => {
        if (rowIndex !== index) return row;

        if (field === 'durationType') {
          return value === 'days'
            ? {
                ...row,
                durationType: 'days',
                months: 0,
                extraMonths: 0,
                totalMonths: 0,
                days: row.days || 7,
              }
            : {
                ...row,
                durationType: 'months',
                months: row.months || 1,
                extraMonths: row.extraMonths || 0,
                totalMonths: (row.months || 1) + (row.extraMonths || 0),
                days: 0,
              };
        }

        const nextValue =
          field === 'price' || field === 'discountLabel'
            ? value
            : Number(value);

        return {
          ...row,
          [field]: nextValue,
        };
      });

      return { ...prev, pricing: updated };
    });
  };

  const handleOpenModal = (plan = null) => {
    if (plan) {
      setEditingPlan(plan);
      setFormData({
        name: plan.name || '',
        iosProductId: getPlanIosProductId(plan),
        isActive: plan.isActive ?? true,
        features: Array.isArray(plan.features) ? plan.features.join(', ') : '',
        pricing:
          Array.isArray(plan.pricing) && plan.pricing.length > 0
            ? plan.pricing.map(normalizePricingForForm)
            : [createEmptyPricingRow()],
      });
    } else {
      setEditingPlan(null);
      setFormData(createInitialForm());
    }

    onOpen();
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      return 'Plan name is required';
    }

    const invalidPricing = formData.pricing.some((pricing) => {
      const priceMissing =
        pricing.price === '' ||
        pricing.price === null ||
        Number.isNaN(Number(pricing.price)) ||
        Number(pricing.price) < 0;

      if (priceMissing) return true;

      if (pricing.durationType === 'days') {
        return toNumber(pricing.days, 0) <= 0;
      }

      return toNumber(pricing.months, 0) <= 0;
    });

    return invalidPricing
      ? 'Please fill valid duration and price for all pricing rows'
      : '';
  };

  const handleSave = async () => {
    const validationMessage = validateForm();
    if (validationMessage) {
      return toast({
        title: 'Validation Error',
        description: validationMessage,
        status: 'warning',
        position: 'top-right',
      });
    }

    setSaving(true);
    try {
      const payload = {
        name: formData.name.trim(),
        iosProductId: formData.iosProductId.trim(),
        isActive: formData.isActive,
        features: formData.features
          .split(',')
          .map((feature) => feature.trim())
          .filter(Boolean),
        pricing: formData.pricing.map(buildPricingPayload),
      };

      const url = editingPlan
        ? `${baseUrl}api/plans/update-plan/${editingPlan._id}`
        : `${baseUrl}api/plans/create-plan`;
      const method = editingPlan ? 'put' : 'post';

      const { data } = await axios[method](url, payload, authHeader);

      if (data.status) {
        toast({
          title: editingPlan ? 'Plan Updated' : 'Plan Created',
          status: 'success',
          position: 'top-right',
        });
        await fetchPlans();
        onClose();
      }
    } catch (error) {
      toast({
        title: 'Operation Failed',
        description: error.response?.data?.message || 'Server Error',
        status: 'error',
        position: 'top-right',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      flexDirection="column"
      w="100%"
      px="25px"
      py="25px"
      mt="80px"
      boxShadow="lg"
      borderRadius="20px"
    >
      <Flex mb="30px" justifyContent="space-between" align="center" gap={4}>
        <Box>
          <Text color={textColor} fontSize="22px" fontWeight="700">
            Subscription Plans
          </Text>
          <Text color={mutedText} fontSize="sm">
            Manage plan pricing, iOS product IDs and features
          </Text>
        </Box>
        <Button
          leftIcon={<AddIcon />}
          colorScheme="brand"
          onClick={() => handleOpenModal()}
        >
          Create Plan
        </Button>
      </Flex>

      {loading ? (
        <Flex justify="center" align="center" minH="200px">
          <Spinner />
        </Flex>
      ) : (
        <Box overflowX="auto">
          <Table variant="simple" color={textColor}>
            <Thead bg={theadBg}>
              <Tr>
                <Th>Plan Name</Th>
                <Th>Pricing Tiers</Th>
                <Th>iOS Product ID</Th>
                <Th>Features</Th>
                <Th>Status</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {plans.length === 0 ? (
                <Tr>
                  <Td colSpan={6} textAlign="center" py={10} color="gray.400">
                    No plans found. Create your first plan.
                  </Td>
                </Tr>
              ) : (
                plans.map((plan) => (
                  <Tr key={plan._id}>
                    <Td fontWeight="700" fontSize="sm" minW="220px">
                      {plan.name}
                    </Td>
                    <Td minW="220px">
                      <Stack direction="row" flexWrap="wrap" gap={2}>
                        {(plan.pricing || []).map((pricing, index) => (
                          <Badge
                            key={`${plan._id}-price-${index}`}
                            colorScheme="purple"
                            variant="subtle"
                            borderRadius="full"
                            px={2}
                            py={1}
                          >
                            {getDurationLabel(pricing)} : Rs.{pricing.price}
                          </Badge>
                        ))}
                      </Stack>
                    </Td>
                    <Td minW="260px">
                      <Badge
                        colorScheme={getPlanIosProductId(plan) ? 'blue' : 'gray'}
                        variant={getPlanIosProductId(plan) ? 'outline' : 'subtle'}
                        borderRadius="md"
                        px={2}
                        py={1}
                        fontSize="10px"
                        whiteSpace="normal"
                      >
                        {getPlanIosProductId(plan) || '-'}
                      </Badge>
                    </Td>
                    <Td>
                      <Text noOfLines={1} fontSize="xs" maxW="180px" color="gray.500">
                        {plan.features?.join(', ') || '-'}
                      </Text>
                    </Td>
                    <Td>
                      <Badge colorScheme={plan.isActive ? 'green' : 'red'}>
                        {plan.isActive ? 'Active' : 'Inactive'}
                      </Badge>
                    </Td>
                    <Td>
                      <IconButton
                        icon={<EditIcon />}
                        size="sm"
                        variant="outline"
                        onClick={() => handleOpenModal(plan)}
                        aria-label="Edit Plan"
                      />
                    </Td>
                  </Tr>
                ))
              )}
            </Tbody>
          </Table>
        </Box>
      )}

      <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="15px">
          <ModalHeader borderBottom="1px solid" borderColor={rowBorder}>
            {editingPlan ? 'Update Plan Details' : 'Create New Subscription Plan'}
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody py={6}>
            <Stack spacing={5}>
              <FormControl isRequired>
                <FormLabel fontWeight="600">Plan Name</FormLabel>
                <Input
                  placeholder="e.g. Professional Plus"
                  value={formData.name}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      name: event.target.value,
                    }))
                  }
                />
              </FormControl>

              <FormControl>
                <FormLabel
                  fontWeight="600"
                  display="flex"
                  alignItems="center"
                  gap={1}
                >
                  iOS Product ID
                  <Tooltip
                    label="Apple App Store product identifier, e.g. com.app.plan_1month"
                    hasArrow
                    fontSize="xs"
                  >
                    <InfoOutlineIcon boxSize={3} color="gray.400" />
                  </Tooltip>
                </FormLabel>
                <Input
                  placeholder="com.yourapp.plan_1m"
                  value={formData.iosProductId}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      iosProductId: event.target.value,
                    }))
                  }
                />
              </FormControl>

              <Box p={4} bg={pricingBg} borderRadius="12px">
                <Flex justify="space-between" align="center" mb={4} gap={3}>
                  <Text fontWeight="700" fontSize="sm">
                    Pricing Variants
                  </Text>
                  <Button
                    size="xs"
                    colorScheme="brand"
                    variant="ghost"
                    leftIcon={<SmallAddIcon />}
                    onClick={addPricingRow}
                  >
                    Add Row
                  </Button>
                </Flex>

                <Stack spacing={3}>
                  {formData.pricing.map((pricing, index) => (
                    <Box
                      key={index}
                      p={3}
                      borderWidth="1px"
                      borderColor={rowBorder}
                      borderRadius="8px"
                      bg={pricingRowBg}
                    >
                      <SimpleGrid
                        columns={{ base: 1, md: pricing.durationType === 'days' ? 4 : 5 }}
                        spacing={3}
                        alignItems="end"
                      >
                        <FormControl>
                          <FormLabel fontSize="xs" fontWeight="600">
                            Type
                          </FormLabel>
                          <Select
                            size="sm"
                            borderRadius="8px"
                            value={pricing.durationType}
                            onChange={(event) =>
                              handlePricingChange(
                                index,
                                'durationType',
                                event.target.value
                              )
                            }
                          >
                            <option value="months">Months</option>
                            <option value="days">Days</option>
                          </Select>
                        </FormControl>

                        {pricing.durationType === 'days' ? (
                          <FormControl isRequired>
                            <FormLabel fontSize="xs" fontWeight="600">
                              Days
                            </FormLabel>
                            <Input
                              size="sm"
                              borderRadius="8px"
                              type="number"
                              min={1}
                              value={pricing.days}
                              onChange={(event) =>
                                handlePricingChange(index, 'days', event.target.value)
                              }
                            />
                          </FormControl>
                        ) : (
                          <>
                            <FormControl isRequired>
                              <FormLabel fontSize="xs" fontWeight="600">
                                Months
                              </FormLabel>
                              <Select
                                size="sm"
                                borderRadius="8px"
                                value={pricing.months}
                                onChange={(event) =>
                                  handlePricingChange(
                                    index,
                                    'months',
                                    event.target.value
                                  )
                                }
                              >
                                {MONTH_OPTIONS.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>

                            <FormControl>
                              <FormLabel fontSize="xs" fontWeight="600">
                                Free Months
                              </FormLabel>
                              <Input
                                size="sm"
                                borderRadius="8px"
                                type="number"
                                min={0}
                                value={pricing.extraMonths}
                                onChange={(event) =>
                                  handlePricingChange(
                                    index,
                                    'extraMonths',
                                    event.target.value
                                  )
                                }
                              />
                            </FormControl>
                          </>
                        )}

                        <FormControl isRequired>
                          <FormLabel fontSize="xs" fontWeight="600">
                            Price
                          </FormLabel>
                          <Input
                            size="sm"
                            borderRadius="8px"
                            type="number"
                            min={0}
                            placeholder="Rs."
                            value={pricing.price}
                            onChange={(event) =>
                              handlePricingChange(index, 'price', event.target.value)
                            }
                          />
                        </FormControl>

                        <IconButton
                          icon={<DeleteIcon />}
                          size="sm"
                          colorScheme="red"
                          variant="ghost"
                          aria-label="Remove pricing row"
                          onClick={() => removePricingRow(index)}
                          isDisabled={formData.pricing.length === 1}
                        />
                      </SimpleGrid>
                    </Box>
                  ))}
                </Stack>
              </Box>

              <FormControl>
                <FormLabel fontWeight="600">Plan Features</FormLabel>
                <Textarea
                  placeholder="24/7 Support, Premium Content, Unlimited Downloads"
                  value={formData.features}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      features: event.target.value,
                    }))
                  }
                  rows={3}
                />
              </FormControl>

              <FormControl display="flex" alignItems="center">
                <FormLabel mb="0" fontWeight="600">
                  Is Plan Active?
                </FormLabel>
                <Switch
                  isChecked={formData.isActive}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      isActive: event.target.checked,
                    }))
                  }
                />
              </FormControl>
            </Stack>
          </ModalBody>

          <ModalFooter borderTop="1px solid" borderColor={rowBorder}>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="brand" isLoading={saving} onClick={handleSave} px={8}>
              {editingPlan ? 'Update Plan' : 'Save Plan'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Card>
  );
}
